import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(
  <g>
    <path d="M12 22.58a2 2 0 0 0 2-2h-4a2 2 0 0 0 2 2zM10 5.41c-2.56.84-4 3.28-4 6.18v5l-2 2v1h16v-1l-2-2v-5.34a6 6 0 0 1-8-5.66v-.18z" />
    <circle fill="currentColor" cx="16" cy="5.58" r="4" />
  </g>,
  'NotificationsUnread',
);
